import { HTMLGenricComponent } from "./../htmlComponent/HTML-Genric-Component.JSON";
import { DisplayRoleResponseJSON } from "./../questionPage/Display-Role-Response.JSON";

export class QuestionOptionRequestJSON {
    sequence: Number;
    optionTextComponentJSON: HTMLGenricComponent;
    displayRoleResponseJSONList: DisplayRoleResponseJSON[];

    constructor(){
        this.optionTextComponentJSON= new HTMLGenricComponent;
        this.displayRoleResponseJSONList= new Array<DisplayRoleResponseJSON>();
    }
}